import script from "./RatingBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./RatingBar.vue?vue&type=script&setup=true&lang=ts"

import "./RatingBar.vue?vue&type=style&index=0&id=76177ed4&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76177ed4"]])

export default __exports__